<template lang="pug">
a.w-menu-item(
  :href='href'
  :class=`{ focus: isFocused, active: isActive, disabled }`
  v-on='listeners'
)
  slot
</template>

<script lang="js">
import { Clickable } from '@/mixins'

export const mixin = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input( value ) {
      this.$emit( 'input', value )
    }
  }
}

export default {
  name: 'MenuItemWidget',
  mixins: [ Clickable ],
  components: {},
  props: {
    href: {
      type: String,
      default: '#'
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.w-menu-item {
  display: block;
  width: 100%;
  color: var(--c-fg);
  padding: var(--pad-menu-item, var(--s-3q) var(--s-lg));
  transition: all 400ms;
  text-align: var(--align-menu-item, left);

  &:link, &:visited {
    color: var(--c-fg);
    text-decoration: none !important;
  }
  &:hover, &:focus {
    transition: all 150ms;
    color: white;
    outline: 0 none !important;
    text-shadow: 0 0 2px cyan, 0 0 4px cyan, 0 0 16px cyan;
    background: rgba(255,255,255,0.1)
  }
  &:active {
    text-shadow: 0 0 2px white, 0 0 4px white, 0 0 16px cyan;
    background: rgba(255,255,255,0.3)
  }
}
</style>
